module.exports = __webpack_public_path__ + "img/mortality.faab2942.svg";